export default "__VITE_ASSET__CcpAhq2Q__"